import { render, staticRenderFns } from "./WidgetImageGallery.vue?vue&type=template&id=b9df7dd4&scoped=true&"
import script from "./WidgetImageGallery.vue?vue&type=script&lang=js&"
export * from "./WidgetImageGallery.vue?vue&type=script&lang=js&"
import style0 from "./WidgetImageGallery.vue?vue&type=style&index=0&id=b9df7dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9df7dd4",
  null
  
)

export default component.exports